module.exports = __webpack_public_path__ + "aa29beb84c9b09df08b9b3306ce52ee0.png";